var $6455a2a2841f35f6$exports = {};
$6455a2a2841f35f6$exports = {
    "collapse": `\u{417}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`,
    "expand": `\u{420}\u{43E}\u{437}\u{433}\u{43E}\u{440}\u{43D}\u{443}\u{442}\u{438}`
};


export {$6455a2a2841f35f6$exports as default};
//# sourceMappingURL=uk-UA.mjs.map
